import { AttachmentTypeEnum } from "./conversation";
import { SystemOfRecord } from "./unified-inbox";

export interface SendCommunicationAttachmentResponse {
  key: string;
  contentType: string;
  fileName: string;
  fileSize: number;
  token: string;
  url?: string;
}
export interface GetCommunicationAttachmentRequest {
  coxAutoMessageId: number | string;
  consumerId: string;
  consumerRecordSystem: SystemOfRecord;
  attachmentId: string;
  XSignature: string;
}

export function getAttachmentType(contentType: string): AttachmentTypeEnum {
  const lower = contentType.toLowerCase();
  if (lower.includes("image/")) {
    return AttachmentTypeEnum.IMAGE;
  } else if (lower.includes("video/")) {
    return AttachmentTypeEnum.VIDEO;
  } else if (lower.includes("audio/")) {
    return AttachmentTypeEnum.AUDIO;
  } else {
    return AttachmentTypeEnum.OTHER;
  }
}

export const supportedAudioExtensions = ["mp3", "mp4", "wav", "ogg"];
